import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";

export class ListUnstyled extends Component {


  constructor(element: HTMLElement, context: PageContext) {
    super(element, context);

  }

  public async init(): Promise<void> {}

}

ComponentFactory.registerComponent("ListUnstyled", ListUnstyled);